"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contract = void 0;
var web3_eth_contract_1 = require("web3-eth-contract");
Object.defineProperty(exports, "Contract", { enumerable: true, get: function () { return web3_eth_contract_1.Contract; } });
//# sourceMappingURL=types.js.map